import React, { useState } from "react";
import { useMyContext } from "../MyContext";
import { ChevronRightIcon, XIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";

function NewsCopy() {
  const contextData = useMyContext();
  const galleryData = contextData.gallery || [];
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState("gallery");

  const currentGallery = galleryData[0];
  const images = currentGallery?.images || [];

  // Helper to get image path from local directory safely
  const getImagePath = (imageName) => {
    try {
      return require(`../image/Plumber Meet/${imageName}`);
    } catch (e) {
      return null;
    }
  };

  // Helper to resolve news images (checks if it's a URL or a local file requirement)
  const getNewsImage = (imageSrc) => {
    if (imageSrc.startsWith("http://") || imageSrc.startsWith("https://")) {
      return imageSrc;
    }
    try {
      return require(`../image/${imageSrc}`);
    } catch (e) {
      return "https://images.unsplash.com/photo-1581092334651-ddf26d9aae9d?auto=format&fit=crop&w=600&q=80";
    }
  };

  const handleImageError = (e) => {
    e.target.style.opacity = "0.5";
  };

  const newsData = [
    {
      id: 1,
      author: "Economic Times",
      title: "POLO PVC PRIVATE LIMITED",
      description:
        "Polo PVC Private Limited is a Non-govt company, incorporated on 02 Sep, 2005. It's a private unlisted company and is classified as 'company limited by shares'. The company has established itself as a leading manufacturer of premium PVC pipes and fittings.",
      image: "https://economictimes.indiatimes.com/photo/msid-74451948,quality-100/et-logo.jpg",
      date: "13 August, 2023",
      url: "https://economictimes.indiatimes.com/company/polo-pvc-private-limited/U25209WB2005PTC105161",
      isExternal: true
    }
  ];

  return (
    <div className="w-full bg-slate-50/50 font-sans overflow-hidden">

      {/* Hero Header Section */}
      <div className="relative w-full bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 pt-20 pb-28 md:pt-24 md:pb-36 lg:pt-28 lg:pb-40 px-6 overflow-hidden">

        {/* Ambient Radial Glow Effect */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto text-center text-white space-y-4 relative z-10">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-2 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse"></span>
            <span className="text-xs font-bold uppercase tracking-wider text-orange-50">Media Center</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight drop-shadow-md">
            News & Gallery
          </h1>

          <p className="text-sm sm:text-base md:text-lg font-normal leading-relaxed text-orange-50 opacity-95 max-w-2xl mx-auto">
            Stay updated with corporate milestones, plumber meet events, press releases, and media coverage from PoloPipes.
          </p>
        </div>

        {/* Clean Solid White Curved SVG Divider */}
        <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-[0] z-10">
          <svg
            className="relative block w-full h-[60px] md:h-[100px]"
            viewBox="0 0 1920 120"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0,120 C640,30 1280,30 1920,120 L1920,120 L0,120 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </div>

      {/* Breadcrumb Section */}
      <div className="bg-white py-3.5 px-6 md:px-12 border-b border-slate-100 relative z-20">
        <div className="max-w-7xl mx-auto flex items-center space-x-2 text-xs sm:text-sm font-medium text-slate-500">
          <Link
            to="/"
            className="text-orange-600 hover:text-orange-700 font-semibold transition-colors"
          >
            Home
          </Link>
          <span className="text-slate-300 font-light">&gt;</span>
          <span className="text-slate-800">News & Media</span>
        </div>
      </div>

      {/* Modern Tab Navigation Bar */}
      <div className="bg-white/90 backdrop-blur-md border-b border-slate-200/80 sticky top-0 z-40 shadow-xs">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex space-x-6 py-3">
            <button
              onClick={() => setActiveTab("gallery")}
              className={`px-5 py-2 rounded-xl font-bold text-xs sm:text-sm transition-all cursor-pointer ${
                activeTab === "gallery"
                  ? "bg-orange-500 text-white shadow-md shadow-orange-500/20"
                  : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
              }`}
            >
              Event Gallery
            </button>
            <button
              onClick={() => setActiveTab("news")}
              className={`px-5 py-2 rounded-xl font-bold text-xs sm:text-sm transition-all cursor-pointer ${
                activeTab === "news"
                  ? "bg-orange-500 text-white shadow-md shadow-orange-500/20"
                  : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"
              }`}
            >
              Media Press
            </button>
          </div>
        </div>
      </div>

      {/* Gallery Tab Content */}
      {activeTab === "gallery" && (
        <section className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="mb-10 space-y-2">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-100 text-orange-700">
              Community Events
            </span>
            <h2 className="text-3xl font-black text-slate-900 tracking-tight">
              Plumber Meet 2024 Highlights
            </h2>
            <p className="text-slate-600 text-xs sm:text-sm max-w-2xl leading-relaxed">
              Capturing interactions from our industry-leading professional event bringing together contractors, plumbing technicians, and regional distributors.
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map((image, index) => {
              const imagePath = getImagePath(image);
              return (
                <div
                  key={index}
                  className="group relative overflow-hidden rounded-3xl border border-slate-200/80 bg-slate-100 shadow-lg shadow-slate-200/50 hover:shadow-2xl hover:shadow-orange-500/10 transition-all duration-300 cursor-pointer aspect-square hover:-translate-y-1.5"
                  onClick={() => setSelectedImage(image)}
                >
                  {imagePath ? (
                    <img
                      src={imagePath}
                      alt={`Gallery item ${index + 1}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      onError={handleImageError}
                    />
                  ) : (
                    <div className="w-full h-full bg-slate-100 flex items-center justify-center">
                      <span className="text-slate-400 font-semibold text-xs">Photo {index + 1}</span>
                    </div>
                  )}

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-xs">
                    <div className="p-3 bg-white/20 rounded-full border border-white/30 text-white">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                    </div>
                  </div>

                  <div className="absolute bottom-3 right-3 bg-slate-900/80 backdrop-blur-md text-white text-[10px] font-bold px-3 py-1 rounded-full border border-white/10">
                    {index + 1}/{images.length}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Event Narrative Card */}
          <div className="mt-12 bg-white border border-slate-200/80 rounded-3xl p-8 shadow-sm relative overflow-hidden">
            <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-orange-500 to-amber-500"></div>
            <h3 className="text-lg font-bold text-slate-900 mb-2">About Plumber Meet Initiatives</h3>
            <p className="text-slate-600 leading-relaxed text-xs sm:text-sm">
              Our annual Plumber Meet initiative strengthens community ties within the piping and construction sector. It provides an active platform to demonstrate BIS-certified product performance, share technical installation best practices, and gather direct field feedback from contractors.
            </p>
          </div>
        </section>
      )}

      {/* News Tab Content */}
      {activeTab === "news" && (
        <section className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="mb-10 space-y-2">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-100 text-orange-700">
              Corporate Updates
            </span>
            <h2 className="text-3xl font-black text-slate-900 tracking-tight">Media & Press Publications</h2>
            <p className="text-slate-600 text-xs sm:text-sm max-w-2xl leading-relaxed">
              Stay informed about PoloPipes' latest corporate growth, business metrics, and industry mentions.
            </p>
          </div>

          {/* News Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsData.map((article) => (
              <article
                key={article.id}
                className="bg-white rounded-3xl border border-slate-200/80 overflow-hidden shadow-lg shadow-slate-200/50 hover:shadow-2xl hover:shadow-orange-500/10 transition-all duration-300 group flex flex-col hover:-translate-y-1.5"
              >
                {/* News Image */}
                <div className="relative h-48 overflow-hidden bg-slate-100 border-b border-slate-100 p-4 flex items-center justify-center">
                  <img
                    src={getNewsImage(article.image)}
                    alt={article.title}
                    className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>

                {/* News Content Details */}
                <div className="p-6 flex-grow flex flex-col justify-between space-y-4">
                  <div className="space-y-2">
                    <div className="flex items-center justify-between">
                      <span className="text-[10px] font-bold text-orange-600 uppercase tracking-wider">
                        {article.author}
                      </span>
                      <span className="text-xs text-slate-400 font-medium">{article.date}</span>
                    </div>

                    <h3 className="text-lg font-bold text-slate-900 group-hover:text-orange-600 transition-colors tracking-tight">
                      {article.title}
                    </h3>

                    <p className="text-slate-500 text-xs sm:text-sm line-clamp-3 leading-relaxed">
                      {article.description}
                    </p>
                  </div>

                  <div>
                    {article.isExternal ? (
                      <a
                        href={article.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-xs font-bold text-slate-900 hover:text-orange-600 transition-colors cursor-pointer"
                      >
                        Read Complete Coverage
                        <ChevronRightIcon className="w-4 h-4 ml-1 text-orange-500" />
                      </a>
                    ) : (
                      <Link
                        to={article.url}
                        className="inline-flex items-center text-xs font-bold text-slate-900 hover:text-orange-600 transition-colors cursor-pointer"
                      >
                        Read Complete Coverage
                        <ChevronRightIcon className="w-4 h-4 ml-1 text-orange-500" />
                      </Link>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      )}

      {/* Lightbox Photo Preview Modal */}
      {selectedImage && (
        <div className="fixed inset-0 z-50 bg-slate-950/90 backdrop-blur-md flex items-center justify-center p-4">
          <div className="relative w-full max-w-4xl">
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 z-10 text-white hover:text-orange-400 transition-colors p-1 cursor-pointer"
              aria-label="Close"
            >
              <XIcon className="w-8 h-8" />
            </button>

            <div className="relative bg-slate-900 rounded-3xl overflow-hidden shadow-2xl flex items-center justify-center max-h-[80vh] p-2 border border-slate-800">
              {(() => {
                const imagePath = getImagePath(selectedImage);
                return imagePath ? (
                  <img
                    src={imagePath}
                    alt="Full size preview"
                    className="max-w-full max-h-[75vh] object-contain rounded-2xl"
                    onError={handleImageError}
                  />
                ) : (
                  <div className="w-full h-96 bg-slate-900 flex items-center justify-center">
                    <span className="text-slate-500 font-medium text-xs">Photo unavailable</span>
                  </div>
                );
              })()}
            </div>

            <div className="text-center mt-4 text-white">
              <p className="text-xs font-bold tracking-widest text-slate-400 uppercase">
                Image {images.indexOf(selectedImage) + 1} of {images.length}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Bottom Global Banner */}
      <section className="bg-slate-900 py-16 px-6 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10 space-y-6">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-500/10 text-orange-400 border border-orange-500/20">
            Media & Communication
          </span>

          <h2 className="text-3xl md:text-4xl font-black text-white tracking-tight">
            Connect With PoloPipes Media Team
          </h2>

          <p className="text-slate-300 max-w-xl mx-auto text-sm md:text-base leading-relaxed">
            For press coverage, event partnerships, or corporate inquiries, reach out to our communications team.
          </p>

          <div>
            <Link to="/contact">
              <button className="bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 hover:opacity-95 text-white font-bold py-3.5 px-8 rounded-xl transition-all shadow-lg shadow-orange-500/20 text-sm cursor-pointer">
                Get in Touch
              </button>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}

export default NewsCopy;